const SyncLoader = ({
  small = false,
}) => (
  <div className={small ? 'sm-loader' : 'bg-loader'}>
    <div className="sync-loader" />
  </div>
);

export default SyncLoader;